import { accountExchangeFee } from 'api/apiDataHelpers'
import { getRequestV2, postRequestV2 } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as allAssetsActions from 'redux/allAssets/allAssets-actions'
import UserActionTypes from 'redux/user/user-types'
import * as tradingDeskActions from './tradingDeskV2-actions'
import TradingDeskActionTypes from './tradingDeskV2-types'

function* signInSuccess() {
    yield
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, signInSuccess)
}

function* startAccountDeposit({ payload: { id, amount, verificationCode } }) {
    try {
        yield postRequestV2(`/user/tradingDesk/depositAccounts/${id}/deposit`, { amount, verificationCode })
        yield put(tradingDeskActions.successAccountDeposit())
    } catch (err) {
        yield put(tradingDeskActions.failureAccountDeposit({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartAccountDeposit() {
    yield takeLatest(TradingDeskActionTypes.START_ACCOUNT_DEPOSIT, startAccountDeposit)
}

function* startAccountWithdraw({ payload: { id, amount, verificationCode } }) {
    try {
        yield postRequestV2(`/user/tradingDesk/accounts/${id}/withdraw`, { amount, verificationCode })
        yield put(tradingDeskActions.successAccountWithdraw())
    } catch (err) {
        yield put(tradingDeskActions.failureAccountWithdraw({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartAccountWithdraw() {
    yield takeLatest(TradingDeskActionTypes.START_ACCOUNT_WITHDRAW, startAccountWithdraw)
}

function* startAddAccount({ payload: data }) {
    try {
        const { data: dataRes } = yield postRequestV2(`/user/tradingDesk/accounts`, { currencyCode: data })
        yield put(tradingDeskActions.successAddAccount(dataRes))
    } catch (err) {
        yield put(tradingDeskActions.failureAddAccount({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartAddAccount() {
    yield takeLatest(TradingDeskActionTypes.START_ADD_ACCOUNT, startAddAccount)
}

function* startExchange({ payload: { id, targetAccountId, amount, type, price } }) {
    try {
        yield postRequestV2(`/user/tradingDesk/accounts/${id}/exchanges`, { targetAccountId, amount, type, price })
        yield put(tradingDeskActions.successExchange())
    } catch (err) {
        yield put(tradingDeskActions.failureExchange({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartExchange() {
    yield takeLatest(TradingDeskActionTypes.START_EXCHANGE, startExchange)
}

function* startGetExchangeRate({ payload: { fromAccountId, toAccountId } }) {
    try {
        const { data } = yield getRequestV2(`/user/tradingDesk/accounts/${fromAccountId}/rate/${toAccountId}`)
        yield put(tradingDeskActions.successGetExchangeRate(data))
    } catch (err) {
        yield put(tradingDeskActions.failureGetExchangeRate({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetExchangeRate() {
    yield takeLatest(TradingDeskActionTypes.START_GET_EXCHANGE_RATE, startGetExchangeRate)
}

function* startGetExchangeFee({ payload: { exchangeType, amount, price, id, targetAccountId } }) {
    try {
        const body = accountExchangeFee({ exchangeType, targetAccountId, amount, price })
        const { data } = yield postRequestV2(`/user/tradingDesk/accounts/${id}/exchanges/fee`, body)
        yield put(tradingDeskActions.successGetExchangeFee(data))
    } catch (err) {
        yield put(tradingDeskActions.failureGetExchangeFee({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetExchangeFee() {
    yield takeLatest(TradingDeskActionTypes.START_GET_EXCHANGE_FEE, startGetExchangeFee)
}

function* startMaxFees({ payload: { key, accountId, service, exchangeCurrencyCode } }) {
    try {
        const { data } = yield postRequestV2(`/user/fees/max/${key}`, { accountId, service, exchangeCurrencyCode })
        yield put(tradingDeskActions.successMaxFees(data))
    } catch (err) {
        yield put(tradingDeskActions.failureMaxFees({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error startMaxFees')
        }
    }
}
export function* onStartMaxFees() {
    yield takeLatest(TradingDeskActionTypes.START_MAX_FEES_V2, startMaxFees)
}

function* pushAccountPage() {
    yield put(allAssetsActions.startFetchAllAssets())
    yield put(tradingDeskActions.finishExchange())
}

export function* onPushAccountPage() {
    yield takeLatest(UserActionTypes.PUSH_ACCOUNT_PAGE, pushAccountPage)
}

export function* tradingDeskSagasV2() {
    yield all([
        call(onSignSuccess),
        call(onStartAccountDeposit),
        call(onStartAccountWithdraw),
        call(onStartAddAccount),
        call(onStartExchange),
        call(onStartGetExchangeRate),
        call(onStartGetExchangeFee),
        call(onStartMaxFees),
        call(onPushAccountPage),
    ])
}
